import React from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'
import GenericThreeColTableWithColors from './GenericThreeColTableWithColors.jsx'

function GenericPieTableTemplate({
  sectionLabel,
  sectionAsOfDate,
  pieChartTableHeader,
  pieChartDescription,
  pieChartId,
  tableData,
}) {
  return (
    <div className="Content">
      <h3>
        {sectionLabel}
        <span className="u-sm-block u-sm-paddingTop1gu">
          {' '}
          as of {formatDateStandard(sectionAsOfDate)}
        </span>
      </h3>

      <div className="Grid u-sm-flexColReverse">
        <div className="u-size6of12 u-sm-sizeFull u-flexGrow5">
          <GenericThreeColTableWithColors
            firstHeading={tableData.firstHeading}
            secondHeading={tableData.secondHeading}
            thirdHeading={tableData.thirdHeading}
            holdings={tableData.holdings}
          />
        </div>

        <div className="u-size6of12 u-sm-sizeFull">
          <table className="js-pie-table Table Table--reversed">
            <thead className="Table-head">
              <tr className="Table-row">
                <th className="Table-header u-alignMiddle u-textCenter tableHeader">
                  {pieChartTableHeader}
                </th>
              </tr>
            </thead>
            <tbody className="Table-body">
              <tr className="Table-row">
                <td className="Table-cell u-paddingHoriz10gu u-textCenter">
                  <div id={pieChartId}></div>
                  <p>{pieChartDescription}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

GenericPieTableTemplate.defaultProps = {
  showDivider: true,
}

export default GenericPieTableTemplate
